import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'news',
    loadChildren: () => import('./news/news.module').then( m => m.NewsPageModule)
  },
  {
    path: 'calendario',
    loadChildren: () => import('./campionato/calendario/calendario.module').then( m => m.CalendarioPageModule)
  },
  {
    path: 'classifica',
    loadChildren: () => import('./campionato/classifica/classifica.module').then( m => m.ClassificaPageModule)
  },
  {
    path: 'primasquadra',
    loadChildren: () => import('./squadre/primasquadra/primasquadra.module').then( m => m.PrimasquadraPageModule)
  },
  {
    path: 'primavera',
    loadChildren: () => import('./squadre/primavera/primavera.module').then( m => m.PrimaveraPageModule)
  },
  {
    path: 'live',
    loadChildren: () => import('./live/live.module').then( m => m.LivePageModule)
  },
  {
    path: 'biglietti',
    loadChildren: () => import('./biglietti/biglietti.module').then( m => m.BigliettiPageModule)
  },
  {
    path: 'vod',
    loadChildren: () => import('./media/vod/vod.module').then( m => m.VodPageModule)
  },
  {
    path: 'photogallery',
    loadChildren: () => import('./media/photogallery/photogallery.module').then( m => m.PhotogalleryPageModule)
  },
  {
    path: 'member',
    loadChildren: () => import('./member/member.module').then( m => m.MemberPageModule)
  },
  {
    path: 'settoregiovanile',
    loadChildren: () => import('./altro/settoregiovanile/settoregiovanile.module').then( m => m.SettoregiovanilePageModule)
  },
  {
    path: 'tablinks',
    loadChildren: () => import('./tablinks/tablinks.module').then( m => m.TablinksPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
